// The page URL reported to Media-Matchers as `webLandingURL`.
//
// Deliberately excludes the query string: the individual tracking params are
// already sent as their own fields, and repeating them inside a URL value
// makes the ping harder for the partner to read (and can carry PII from a
// prefilled deep link into a field that isn't meant to hold it).
export function getWebLandingURL(): string {
  if (typeof window === 'undefined') return ''
  return `${window.location.origin}${window.location.pathname}`
}
